import { render } from "./TheVideo.vue?vue&type=template&id=57bdbe60&scoped=true"
import script from "./TheVideo.vue?vue&type=script&lang=js"
export * from "./TheVideo.vue?vue&type=script&lang=js"

import "./TheVideo.vue?vue&type=style&index=0&id=57bdbe60&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-57bdbe60"

export default script